import { Select } from '@/shared/ui';
import { StringFilterSelectionType } from '../../model/types';

const OPTIONS: { value: StringFilterSelectionType; label: string }[] = [
  {
    label: 'Include',
    value: StringFilterSelectionType.INCLUDE,
  },
  {
    label: 'Exclude',
    value: StringFilterSelectionType.EXCLUDE,
  },
  {
    label: 'Contains',
    value: StringFilterSelectionType.CONTAINS,
  },
  {
    label: 'Does not contain',
    value: StringFilterSelectionType.NOT_CONTAIN,
  },
];

interface Props {
  value?: StringFilterSelectionType;
  onChange: (v: StringFilterSelectionType) => void;
}

export function FilterSelectionTypeSelect({ value, onChange }: Props) {
  return (
    <Select
      sx={{ width: '100%' }}
      label="Filter type"
      value={value || StringFilterSelectionType.INCLUDE}
      options={OPTIONS}
      onChange={onChange}
    />
  );
}
